import http from "infra/http";

export async function getTotalPeso(unidades: string[]) {
  const { data } = await http.get<{ peso: number }>(`/v1/unidades/total-peso`, {
    params: { unidades },
  });

  return data.peso;
}
